import { useEffect } from 'react';

export default function BitrixChat() {
  useEffect(() => {
    const scriptId = 'bitrix-chat-script';

    if (document.getElementById(scriptId)) return;

    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = `https://cdn-ru.bitrix24.ru/b30159860/crm/site_button/loader_5_fc44xl.js?${
      Date.now() / 60000 || 0
    }`;

    document.body.appendChild(script);
  }, []);

  return null;
}
